import '@fontsource/montserrat/variable.css';
import '@fontsource/inconsolata/index.css';
import ReactDOM from 'react-dom/client';
import './utils/sentry/sentry';

import { ChakraProvider } from '@chakra-ui/react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { configureApiClient, configureCognitoClient } from '@aslanpay/portal-common-lib';

import apiConfig from 'app/constants/api';
import authConfig from 'app/constants/aws';
import { getActiveLoginContext, getPendingSsoContext } from 'app/constants/authentication';

import { AuthContextProvider } from 'app/contexts/Auth';
import { BrandingProvider } from 'app/contexts/Branding';

import theme from 'app/styles/theme';

import { HelmetProvider } from 'react-helmet-async';

import { applyActiveContextOrigin } from 'app/utils/api/applyActiveContextOrigin';
import { reportHostedUiFailures } from 'app/utils/sentry/reportHostedUiFailures';

import Routes from './routes';

configureApiClient(apiConfig);
applyActiveContextOrigin();
// Configure the right pool in a single Auth.configure call. On an SSO callback landing the URL still
// carries the ?code=, so a second configure (from a follow-up setCognitoContext) would land
// mid-exchange and drop Amplify's one-shot OAuth handling.
const initialLoginContext = getPendingSsoContext() ?? getActiveLoginContext();
reportHostedUiFailures(initialLoginContext);
configureCognitoClient(authConfig, initialLoginContext);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <HelmetProvider>
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <AuthContextProvider>
          <BrandingProvider>
            <Routes />
          </BrandingProvider>
        </AuthContextProvider>
      </QueryClientProvider>
    </ChakraProvider>
  </HelmetProvider>
);
